import { Connector } from '../common/redux/api/web-api'

export const IsSchukoConnector = (connector: Connector): boolean => connector?.connectorFunctionType === 'Schuko'

const findSchukoConnector = (connectors: Connector[] | undefined): Connector | undefined =>
    connectors?.find(IsSchukoConnector)

export default findSchukoConnector
